/** Workflow states for contact submissions (MGMT dashboard). */

export const CONTACT_STATUSES = [
  "new",
  "in_progress",
  "reached_out",
  "spam",
  "block",
  "completed",
];

export const CONTACT_STATUS_LABELS = {
  new: "New",
  in_progress: "In progress",
  reached_out: "Reached out",
  spam: "Spam",
  block: "Block",
  completed: "Completed",
};

export function isValidContactStatus(value) {
  return CONTACT_STATUSES.includes(value);
}
